import isString from "lodash/isString";
import includes from "lodash/includes";
import replace from "lodash/replace";
import assign from "lodash/assign";
const filesTypeMap = {
    xml: "application/xml",
    csv: "text/csv",
    txt: "text/plain",
    json: "application/json",
    pdf: "application/pdf",
    png: "image/png",
    jpg: "image/jpeg"
};
export function saveFile({ fileName = "Unknown", fileExtension, fileType, file }) {
    let link;
    let url;
    try {
        if (!fileName || !isString(fileName)) {
            throw new Error("Некорректное имя файла");
        }
        if ((!fileType || !isString(fileType)) && (!fileExtension || !isString(fileExtension))) {
            throw new Error("Некорректное расширение файла");
        }
        if (!(isString(file) || file instanceof Blob || file instanceof File)) {
            throw new Error("Некорректный тип файла");
        }
        const fullFileName = fileExtension ? `${fileName}.${fileExtension}` : fileName;
        const mimeType = fileType !== null && fileType !== void 0 ? fileType : (fileExtension ? filesTypeMap[fileExtension] : "application/octet-stream");
        const blob = new Blob([file], { type: mimeType });
        url = window.URL.createObjectURL(blob);
        link = document.createElement("a");
        link.href = url;
        link.download = fullFileName;
        document.body.appendChild(link);
        link.click();
        return {
            isSuccess: true,
            fileName
        };
    }
    catch (error) {
        return {
            isSuccess: false,
            fileName,
            errorMessage: String(error)
        };
    }
    finally {
        if (link) {
            document.body.removeChild(link);
        }
        if (url) {
            window.URL.revokeObjectURL(url);
        }
    }
}
export function saveFileBlobResponse({ response }) {
    const contentDisposition = response.headers["content-disposition"];
    let fileName;
    if (includes(contentDisposition, "attachment")) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        if (matches != null && matches[1]) {
            fileName = replace(matches[1], /['"]/g, "");
        }
    }
    const fileType = response.headers["content-type"] || "application/octet-stream";
    const res = saveFile({
        fileName,
        fileType,
        file: response.data
    });
    if (res.isSuccess) {
        return response;
    }
    return Promise.reject(assign(new Error(res.errorMessage), { fileName: res.fileName }));
}
